/* eslint-disable react-hooks-extra/no-direct-set-state-in-use-effect */
import type { TextareaProps as PrimativeTextareaProps } from '@connected/ui/components/textarea';

import { Textarea as TextareaPrimitive } from '@connected/ui/components/textarea';
import { useEffect, useRef, useState } from 'react';

import type { PrimativeFieldProps, PrimativeFormPropsOmit } from '../../lib/utils';

export type TextareaProps = Omit<PrimativeTextareaProps, PrimativeFormPropsOmit> & PrimativeFieldProps<string | null> & {};

export function Textarea(props: TextareaProps) {
    const { name, value, onChange, onBlur, className, disabled, id, ...restProps } = props;

    const [textValue, setTextValue] = useState(value ?? '');
    const lastSentValueRef = useRef<string | null | undefined>(undefined);

    useEffect(() => {
        // Skip sync when this is our own change echoing back to preserve cursor position
        if (value === lastSentValueRef.current) {
            return;
        }

        if (value === undefined || value === null) {
            setTextValue('');
        }
        else {
            setTextValue(value);
        }
    }, [value]);

    function handleChange(event: React.ChangeEvent<HTMLTextAreaElement>) {
        const newValue = event.target.value;

        setTextValue(newValue);

        if (newValue === '') {
            lastSentValueRef.current = null;
            onChange(null);
        }
        else {
            lastSentValueRef.current = newValue;
            onChange(newValue);
        }
    }

    return (
        <TextareaPrimitive
            id={id ?? name}
            name={name}
            value={textValue}
            onChange={handleChange}
            onBlur={onBlur}
            disabled={disabled}
            className={className}
            {...restProps}
        />
    );
}

Textarea.displayName = 'Textarea';
